export const parseExperience = (startDate: Date) => {
  if (!startDate) return 0;

  const inputDate = new Date(startDate);
  if (!inputDate) {
    throw new Error('유효하지 않은 날짜 형식입니다.');
  }

  const today = new Date();

  let yearsDifference = today.getFullYear() - inputDate.getFullYear();

  if (
    today.getMonth() < inputDate.getMonth() ||
    (today.getMonth() === inputDate.getMonth() &&
      today.getDate() < inputDate.getDate())
  ) {
    yearsDifference--;
  }

  return yearsDifference;
};
